import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class DateHandlingService {
  toUseableString(dateValue, position) {
    const jsDate = new Date(dateValue);
    if (position === 'start') {
      return DateTime.fromJSDate(jsDate)
        .startOf('day')
        .toUTC()
        .toJSDate()
        .toUTCString();
    } else if (position === 'end') {
      return DateTime.fromJSDate(jsDate)
        .plus({ days: 1 })
        .startOf('day')
        .toUTC()
        .toJSDate()
        .toUTCString();
    }
    return DateTime.fromJSDate(jsDate).toUTC().toJSDate().toUTCString();
  }

  toUseableIso(dateValue, position) {
    const jsDate = new Date(dateValue);
    if (position === 'start') {
      return DateTime.fromJSDate(jsDate).startOf('day').toISO();
    } else if (position === 'end') {
      return DateTime.fromJSDate(jsDate).plus({ days: 1 }).toISO();
    }
    return DateTime.fromJSDate(jsDate).toISO();
  }

  toUtcIsoString(dateValue, position) {
    const jsDate = new Date(dateValue);
    if (position === 'start') {
      return DateTime.fromJSDate(jsDate).startOf('day').toUTC().toISO();
    } else if (position === 'end') {
      return DateTime.fromJSDate(jsDate).plus({ days: 1 }).toUTC().toISO();
    }
    return DateTime.fromJSDate(jsDate).toUTC().toISO();
  }

  toTruncatedIso(dateValue) {
    const jsDate = new Date(dateValue);
    return DateTime.fromJSDate(jsDate)
      .startOf('day')
      .toUTC()
      .toISO()
      .substring(0, 10);
  }

  thirtyDays(value?) {
    const startDate = DateTime.now(value)
      .minus({ days: 30 })
      .startOf('day')
      .toUTC()
      .toJSDate()
      .toUTCString();
    const endDate = DateTime.now(value)
      .plus({ days: 1 })
      .startOf('day')
      .toUTC()
      .toJSDate()
      .toUTCString();

    return {
      start: startDate,
      end: endDate,
    };
  }
}
